import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import * as MessageActions from '../../common/messageBox/actions/actions';

export const clearMaintainForecastAgenciesList = () => {
  return {
    'type': ActionTypes.CLEAR_MAINTAIN_FORECAST_AGENCIES_LIST,
  };
};


export const fetchAgenciesByDealerAll = (dealer) =>
  apiActionCreator({
    'endpoint': `/dealers/${dealer}/agencies-all`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_MAINTAIN_SALE_FORECAST,
      ActionTypes.FETCHED_MAINTAIN_SALE_FORECAST,
      [ActionTypes.FETCHED_MAINTAIN_SALE_FORECAST_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });


export const updateAgencyStatus = (data) => (dispatch) => {
  const {dealer} = data;
  return dispatch(
    apiActionCreator({
      'endpoint': '/dealers/update-agency',
      'authenticated': true,
      'types': [
        ActionTypes.EDITING_MAINTAIN_SALE_FORECAST,
        [
          () => {
            dispatch(fetchAgenciesByDealerAll(dealer));
            return {
              'type': ActionTypes.EDITED_MAINTAIN_SALE_FORECAST,
            };
          },
          (response) => MessageActions.addMessageBoxInfo('Registro Actualizado'),
        ],
        [ActionTypes.EDITED_MAINTAIN_SALE_FORECAST_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'PUT',
      'data': data,
    })
  );
};
  
